import styled from "styled-components"
import { isMobile } from "react-device-detect"

export const Wrapper = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  ${isMobile && `flex-direction: column;`}
  & > div {
    width: ${isMobile ? "100vw" : "45%"};
  }
`
export const Cell = styled.div`
  margin-bottom: ${isMobile ? 0 : "3rem"};
`

export const Description = styled.p``
